<template>
  <v-container id="program" style="min-height: 700px; background-color: white" class="rounded-lg gradient">
    <v-row>
      <v-col cols="12" md="2">
        <v-banner color="purple" dark shaped height="50px" width="180px">
          <h2>PROGRAM</h2>
        </v-banner>
      </v-col>
    </v-row>
    <!--    <p>Coming soon!</p>-->
    <v-row>
      <v-container>
        <h2>8/11</h2>
        <v-timeline align-top dense>
          <v-timeline-item fill-dot>
            <v-row style="">
              <v-col cols="2">
                <strong>8:30-9:00</strong>
              </v-col>
              <v-col class="mx-6">
                Check In
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>9:00-9:10</strong>
              </v-col>
              <v-col class="mx-6">
                Opening Ceremony
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>9:10-10:10</strong>
              </v-col>
              <v-col class="mx-6">
                Keynote I
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>10:10-11:10</strong>
              </v-col>
              <v-col class="mx-6">
                Keynote II
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>11:00-12:00</strong>
              </v-col>
              <v-col>

                <v-expansion-panels tile flat>
                  <v-expansion-panel style="background-color: #00000000">
                    <v-expansion-panel-header>W1</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table style="background-color: #00000000">
                        <thead>
                        <tr>
                          <th class="text-center">
                            Title
                          </th>
                          <th class="text-center">
                            Authors
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="item in W1"
                            :key="item.title"
                        >
                          <td>{{ item.title }}</td>
                          <td>{{ item.authors }}</td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>12:00-14:00</strong>
              </v-col>
              <v-col class="mx-6">
                Lunch
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>14:00-15:00</strong>
              </v-col>
              <v-col>
                <v-expansion-panels tile flat>
                  <v-expansion-panel style="background-color: #00000000">
                    <v-expansion-panel-header>O1</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table style="background-color: #00000000">
                        <thead>
                        <tr>
                          <th class="text-center">
                            Title
                          </th>
                          <th class="text-center">
                            Authors
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="item in O1"
                            :key="item.title"
                        >
                          <td>{{ item.title }}</td>
                          <td>{{ item.authors }}</td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>15:00-15:30</strong>
              </v-col>
              <v-col class="mx-6">
                Tea Break
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>15:30-16:30</strong>
              </v-col>
              <v-col>
                <v-expansion-panels tile flat>
                  <v-expansion-panel style="background-color: #00000000">
                    <v-expansion-panel-header>E1</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table style="background-color: #00000000">
                        <thead>
                        <tr>
                          <th class="text-center">
                            Title
                          </th>
                          <th class="text-center">
                            Authors
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="item in E1"
                            :key="item.title"
                        >
                          <td>{{ item.title }}</td>
                          <td>{{ item.authors }}</td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>16:30-17:30</strong>
              </v-col>
              <v-col>
                <v-expansion-panels tile flat>
                  <v-expansion-panel style="background-color: #00000000">
                    <v-expansion-panel-header>B1</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table style="background-color: #00000000">
                        <thead>
                        <tr>
                          <th class="text-center">
                            Title
                          </th>
                          <th class="text-center">
                            Authors
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="item in B1"
                            :key="item.title"
                        >
                          <td>{{ item.title }}</td>
                          <td>{{ item.authors }}</td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>17:30-18:00</strong>
              </v-col>
              <v-col>
                <v-expansion-panels tile flat>
                  <v-expansion-panel style="background-color: #00000000">
                    <v-expansion-panel-header>Special Session</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table style="background-color: #00000000">
                        <thead>
                        <tr>
                          <th class="text-center">
                            Title
                          </th>
                          <th class="text-center">
                            Authors
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="item in S"
                            :key="item.title"
                        >
                          <td>{{ item.title }}</td>
                          <td>{{ item.authors }}</td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>18:30-20:00</strong>
              </v-col>
              <v-col class="mx-6">Welcome Party</v-col>
            </v-row>
          </v-timeline-item>
        </v-timeline>
      </v-container>
    </v-row>
    <v-row>
      <v-container>
        <h2>8/12</h2>
        <v-timeline align-top dense>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>9:00-10:00</strong>
              </v-col>
              <v-col class="mx-6">Keynote III</v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>10:00-11:00</strong>
              </v-col>
              <v-col>
                <v-expansion-panels tile flat>
                  <v-expansion-panel style="background-color: #00000000">
                    <v-expansion-panel-header>B2</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table style="background-color: #00000000">
                        <thead>
                        <tr>
                          <th class="text-center">
                            Title
                          </th>
                          <th class="text-center">
                            Authors
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="item in B2"
                            :key="item.title"
                        >
                          <td>{{ item.title }}</td>
                          <td>{{ item.authors }}</td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>11:00-12:00</strong>
              </v-col>
              <v-col>
                <v-expansion-panels tile flat>
                  <v-expansion-panel style="background-color: #00000000">
                    <v-expansion-panel-header>O2</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table style="background-color: #00000000">
                        <thead>
                        <tr>
                          <th class="text-center">
                            Title
                          </th>
                          <th class="text-center">
                            Authors
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="item in O2"
                            :key="item.title"
                        >
                          <td>{{ item.title }}</td>
                          <td>{{ item.authors }}</td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>12:00-14:00</strong>
              </v-col>
              <v-col class="mx-6">
                Lunch
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>14:00-15:00</strong>
              </v-col>
              <v-col>
                <v-expansion-panels tile flat>
                  <v-expansion-panel style="background-color: #00000000">
                    <v-expansion-panel-header>W2</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table style="background-color: #00000000">
                        <thead>
                        <tr>
                          <th class="text-center">
                            Title
                          </th>
                          <th class="text-center">
                            Authors
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="item in W2"
                            :key="item.title"
                        >
                          <td>{{ item.title }}</td>
                          <td>{{ item.authors }}</td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>15:30-15:30</strong>
              </v-col>
              <v-col class="mx-6">
                Tea Break
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>15:30-16:30</strong>
              </v-col>
              <v-col>
                <v-expansion-panels tile flat>
                  <v-expansion-panel style="background-color: #00000000">
                    <v-expansion-panel-header>E2</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table style="background-color: #00000000">
                        <thead>
                        <tr>
                          <th class="text-center">
                            Title
                          </th>
                          <th class="text-center">
                            Authors
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="item in E2"
                            :key="item.title"
                        >
                          <td>{{ item.title }}</td>
                          <td>{{ item.authors }}</td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>16:30-17:50</strong>
              </v-col>
              <v-col>
                <v-expansion-panels tile flat>
                  <v-expansion-panel style="background-color: #00000000">
                    <v-expansion-panel-header>Best Paper Presentations</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table style="background-color: #00000000">
                        <thead>
                        <tr>
                          <th class="text-center">
                            Title
                          </th>
                          <th class="text-center">
                            Authors
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="item in A"
                            :key="item.title"
                        >
                          <td>{{ item.title }}</td>
                          <td>{{ item.authors }}</td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item fill-dot>
            <v-row>
              <v-col cols="2">
                <strong>17:50-18:20</strong>
              </v-col>
              <v-col class="mx-6">
                Award & Closing Ceremony
              </v-col>
            </v-row>
          </v-timeline-item>
        </v-timeline>
      </v-container>
    </v-row>
    <v-container class="mx-9">
      <ul style="font-weight: 300; color: #303030">
        <li>W: Wireless Communications and Networking Symposium</li>
        <li>O: Optical Communications and Photonics Symposium</li>
        <li>E: Emerging Networks and Future Internet Symposium</li>
        <li>B: Big Data and Machine Learning Symposium</li>
      </ul>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "Program",
  data() {
    return {
      W1: [
        {
          title: "AoI Aware Channel Scheduling for V2N Status Reporting Based on Deep Reinforcement Learning",
          authors: "Bingchun Yu (Shenzhen university, China); Chongtao Guo and Bin Liao (Shenzhen University, China)"
        },
        {
          title: "Secrecy Rate Optimization for Secure communication in IRS-Aided UAV Systems",
          authors: "ZhenSheng Ye (Shenzhen University, China); Gongchao Su (Faculty of Information Engineering, Shenzhen University, China); Mingjun Dai, Bin Chen, Xiaohui Lin and Hui Wang (Shenzhen University, China)\n"
        },
        {
          title: "Modulation Classification Based on Eye Diagrams and Deep Learning\n",
          authors: "Alhussain Almarhabi, Hatim Alhazmi, Abdullah Samarkandi and Yu-Dong Yao (Stevens Institute of Technology, USA)\n"
        },
        {
          title: "Policy Gradient based Resources Allocation for Energy Harvested Edge Computing\n",
          authors: "Senlei Bao, Shubin Zhang and Kaikai Chi (Zhejiang University of Technology, China)\n"
        },
      ],
      O1: [
        {
          title: "Optimized NRZ / RZ-OOK over a 2-Channel Mode-Division Multiplexing for Interconnect and Metro Applications\n",
          authors: "Amin Malekmohammadi (California State University, Bakersfield, USA); Rabiu Imam Sabitu (Kano University of Science and Technology Wudil, Nigeria)\n"
        },
        {
          title: "An ILP-based Approach for Dual-Layer Optimization in Large-Scale Optical Networks\n",
          authors: "Junyan Liu, Fan Zhang, Kerong Yan, Junqi Ma and Bo Bai (Huawei Technologies Co., Ltd., Hong Kong)\n"
        },
        {
          title: "Bi-directional Central-Coordinated Resource-Reserved Multiple Access (CRMA) Scheme Analysis with TCP and UDP Traffic\n",
          authors: "Ajay Shukla and Anjali Gupta (Indian Institute of Technology, Delhi, India); Abhishek Dixit (Indian Institute of Technology Delhi & IBBT, India)\n"
        },
        {
          title: "Silicon Photomultiplier (SiPM) Selection and Parameter Analysis in Visible Light Communications\n",
          authors: "Cuiwei He (Japan Advanced Institute of Science and Technology, Japan); Yuto Lim (Japan Advanced Institute of Science and Technology (JAIST) & School of Information Science, Japan)\n"
        },
      ],
      E1: [
        {
          title: "Multipath Routing for Traffic Engineering with Hypergraph Attention Enhanced Multi-Agent Reinforcement Learning\n",
          authors: "Xuhong Cai and Yi Chen (The Chinese University of Hong Kong, Shenzhen, China)\n"
        },
        {
          title: "Non-Orthogonal Multiple Access Assisted Secure Dual-UAV Mobile Edge Computing Networks\n",
          authors: "Guangyuan Ji, Minghui Dai and Yuan Wu (University of Macau, Macao); Liping Qian (Zhejiang University of Technology, China); Zhou Su (Xi'an Jiaotong University, China)\n"
        },
        {
          title: "A Feasibility Study on Integrated Sensing and Communication in Cooperative Network\n",
          authors: "Xia Shen (China Academy of Information and Communication Technology, China); Li HuJun, Yuan Wang, Zhiqing Wei and Zhiyong Feng (Beijing University of Posts and Telecommunications, China); Zhiqin Wang (China Academy of Information and Communications Technology, China)\n"
        },
        {
          title: "Joint Resource Allocation and Scheduling for Wireless Power Transfer Aided Federated Learning\n",
          authors: "Yuxiao Song (University of Macau, China); Guangyuan Ji, Minghui Dai and Yuan Wu (University of Macau, Macao); Liping Qian (Zhejiang University of Technology, China); Bin Lin (Dalian Maritime University, China)\n"
        },
      ],
      B1: [
        {
          title: "Sample-Efficient Cross-Domain WiFi Indoor Crowd Counting via Few-shot Learning\n",
          authors: "Huawei Hou, Suzhi Bi, Lili Zheng, Xiaohui Lin and Zhi Quan (Shenzhen University, China)\n"
        },
        {
          title: "Large-Scale Multi-Channel Transformer-based Speaker Identification with Knowledge Transfer Using Harmonic-Percussive Source Separation\n",
          authors: "Yuejiao Xie, Jingjing Tang and Nan Yang (CUHKSZ, China); Man-On Pun (The Chinese University of Hong Kong, Shenzhen, China)\n"
        },
        {
          title: "Recognition of Channel Codes based on BiLSTM-CNN\n",
          authors: "Xingrong Huang and Shujun Sun (Huaqiao University, China); Xi Yang (Jishou University, China); Shengliang Peng (Huaqiao University, China)\n"
        },
        {
          title: "An Automated Framework for Change Detection with Contextual Understanding Using Remote Sensing Data\n",
          authors: "Eryan Chen, Ling Ye, Mingxing Liu and Ming Liu (Mizarvision, China)\n"
        },
      ],
      S: [
        {
          title: "Matroidal Entropy Functions: Constructions, Characterizations and Representations\n",
          authors: "Qi Chen (Xidian University)\n"
        },
        {
          title: "Wide-stripe Erasure coding for Distributed Storage\n",
          authors: "Yuchong Hu (Huazhong University of Science and Technology)\n"
        },
        {
          title: "Zero-error Capacity Problems\n",
          authors: "Qi Cao (Xidian University)\n"
        },
        {
          title: "Random Linear Network Coding in Full-duplex Relay Networks\n",
          authors: "Qifu Sun (University of Science and Technology Beijing)\n"
        },
      ],
      B2: [
        {
          title: "Modulation Classification of QAM Signals with Different Phase Noise Levels Using Deep Learning\n",
          authors: "Hatim Alhazmi, Alhussain Almarhabi, Abdullah Samarkandi and Yu-Dong Yao (Stevens Institute of Technology, USA)\n"
        },
        {
          title: "Bluetooth Fingerprint based Indoor Localization using Bi-LSTM\n",
          authors: "Senchun Hu and Kun He (Huaqiao University, China); Xi Yang (Jishou University, China); Shengliang Peng (Huaqiao University, China)\n"
        },
        {
          title: "Non-intrusive Intelligibility Prediction of Noise-suppressed Speech Based on Neural Network\n",
          authors: "Fuqiang Ye, Zexin Liu and Fei Chen (Southern University of Science and Technology, China)\n"
        },
      ],
      O2: [
        {
          title: "Block Markov Superposition Transmission of Algebraic QC-LDPC Codes for Optical Fiber Communication\n",
          authors: "Juewei Wang and Xiao Ma (Sun Yat-sen University, China); Chao Chen (Xi'dian, China)\n"
        },
        {
          title: "Iterative Decision-Directed Diversity Combining in Asymmetrically Clipped Optical OFDM\n",
          authors: "Cuiwei He (Japan Advanced Institute of Science and Technology, Japan); Yuto Lim (Japan Advanced Institute of Science and Technology (JAIST) & School of Information Science, Japan)\n"
        },
        {
          title: "Nonlinear Compensation based on Bidirectional Gate Recurrent Unit in Underwater Visible Light Communication System\n",
          authors: "Jifan Cai, Xianhao Lin, Guojin Qin, Nan Chi and Ruizhe Jin (Fudan University, China)\n"
        },
      ],
      W2: [
        {
          title: "Blind Constant Modulus Multiuser Detection in Multipath Fading Channel via Contracting Regularized BFGS\n",
          authors: "Xue Xiong, Ying Liu, Chongtao Guo and Bin Liao (Shenzhen University, China)\n"
        },
        {
          title: "On Maximum-Likelihood Detection via Improved Sphere Decoding\n",
          authors: "Bowen Wang (China Telecom Research Institute, China); Wu Jingzhou (China Telecom Research Institude, China); Hang Yin (China Telecom Research Institute, China); Shan Yang, Jianchi Zhu, Xiaoming She and Peng Chen (China Telecom, China)\n"
        },
        {
          title: "Joint Trajectory and Power Control for Secure Dual-UAV Communications Against Air and Ground Eavesdropping\n",
          authors: "Zewu Zhu (Shenzhen University, China); Gongchao Su (Faculty of Information Engineering, Shenzhen University, China); Mingjun Dai, Bin Chen, Xiaohui Lin and Hui Wang (Shenzhen University, China)\n"
        },
      ],
      E2: [
        {
          title: "Prediction-based Resource Slicing for Service Level Agreement Guarantee: A Deep Learning Approach\n",
          authors: "Shengyu Gao and Heng Zhang (Shanghai University, China); Zuoqiao Shi (Wenzhou Branch of China Tower Co. LTD, China); Yanzan Sun, Shunqing Zhang and Xiaojing Chen (Shanghai University, China)\n"
        },
        {
          title: "Wireless Power Transfer for Battery-less Implantable Medical Devices using Hook-shaped Defected Ground Structure Resonators\n",
          authors: "Jean Maurice Mwizerwa (Egypt-Japan University of Science and Technology, Egypt); Ahmed Sayed Ahmed Abdelhamid Allam (Egypt-Japan University of Science and Technology (E-JUST), Egypt); Adel Bedair (Egypt-Japan University of Science and Technology, Egypt); Tanemasa Asano (Kyushu University, Japan)\n"
        },
        {
          title: "Computing Resource Allocation for Heterogeneous Coded Distributed Computing\n",
          authors: "Mingjun Dai, Jialong Yuan, Yanli Tong, Lan Wang and Xiaohui Lin (Shenzhen University, China)\n"
        },
        {
          title: "Rydberg Atomic Sensor Sensitivity Optimization Using Detuned Microwave Field",
          authors: "Shanchi Wu, Chen Gong and Shangbin Li (University of Science and Technology of China, China); Rui Ni (Huawei Technologies Co Ltd, China); Jinkang Zhu (University of Science and Technology of China, China)"
        }
      ],
      A: [
        {
          title: "Secure Rate-Splitting for MIMO Broadcast Channel with Imperfect CSIT and a Jammer\n",
          authors: "Tong Zhang (Southern University of Science and Technology, China); Dongsheng Chen (Southern University of Science and Technology & None, China); Na Li (Beijing University of Posts and Telecommunications, China); Yufan Zhuang, Bojie Lv and Rui Wang (Southern University of Science and Technology, China)\n"
        },
        {
          title: "Online 3D Placement for UAV-aided Free-space Optical Communication under Shadowing\n",
          authors: "Yinjun Wang (The Chinese University of Hong Kong, Shenzhen, USA); Junting Chen (The Chinese University of Hong Kong, Shenzhen, China)\n"
        },
        {
          title: "Two-tier Multi-access Partial Computation Offloading via NOMA: A Hybrid Deep Learning Approach for Energy Minimization\n",
          authors: "Yang Li (University of Macau, China); Yuan Wu (University of Macau, Macao); Suzhi Bi (Shenzhen University, China); Liping Qian (Zhejiang University of Technology, China); Tony Q. S. Quek (Singapore University of Technology and Design, Singapore); Cheng-Zhong Xu (University of Macau, China); Zhiguo Shi (Zhejiang University, China)\n"
        },
        {
          title: "A Three-layer Security Assurance Model for a Decentralized Federated Learning System\n",
          authors: "Jinyu Liu, Ziyang Wang, Qing Yang and Xiaoxiao Wu (Shenzhen University, China)\n"
        },
      ]
    }
  }
}
</script>

<style scoped>
#program {
  background-color: #ffffff;
  /*font-family: 'Times New Roman', serif;*/
}
</style>
